// src/components/PrivateRoute.jsx
import { Navigate } from "react-router-dom";

export default function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role"); // à stocker après login
  if (!token || role !== "admin") {
    return <Navigate to="/login" replace />;
  }
  return children;
}
